export default class BigTicketBonanzaGame{
    constructor(api) {
        this.api = api;
        this.BigTicketBonanzaGameClass = null;
    }

    async init(instance) {
        if (!this.BigTicketBonanzaGameClass) {
            if (instance.data && instance.data.cdn && instance.data.cdn.js) {
                await this.api.util.loadJS(instance.data.cdn.js);
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileApp &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.bigTicketBonanzaGame &&
                this.api.settings.widgetsUrl.bigTicketBonanzaGame.js
            ) {
                await this.api.util.loadJS([this.api.settings.widgetsUrl.bigTicketBonanzaGame.js]);
            }

            if (instance.data && instance.data.cdn && instance.data.cdn.css) {
                await this.api.util.loadCSS(instance.data.cdn.css);
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileApp &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.bigTicketBonanzaGame &&
                this.api.settings.widgetsUrl.bigTicketBonanzaGame.css
            ) {
                await this.api.util.loadCSS([this.api.settings.widgetsUrl.bigTicketBonanzaGame.css]);
            }
     
            this.BigTicketBonanzaGameClass = new window.Widget_bigTicketBonanzaGame.default(this.api, instance.instance);
        }
    }
}
